import React, { useState } from 'react';

// ─── Mock Data ────────────────────────────────────────────────────────────────

const guests = [
  {
    id: 1,
    name: 'Sarah van der Berg',
    email: 'sarah.vdb@email.nl',
    nationality: 'Dutch',
    room: 'Shared Triple - Lotus Room',
    dietary: 'Vegan',
    allergies: ['Tree nuts'],
    arrival: 'March 15, 14:30',
    flight: 'KL1234',
    totalPaid: 1950,
    totalDue: 2925,
    installments: '2/3',
    waiverSigned: true,
    intakeComplete: true,
    specialRequests: '',
  },
  {
    id: 2,
    name: 'Michael Chen',
    email: 'mchen@gmail.com',
    nationality: 'American',
    room: 'Private - Bamboo Room',
    dietary: 'Omnivore',
    allergies: ['Tree nuts'],
    arrival: 'March 15, 11:00',
    flight: 'UA904',
    totalPaid: 3450,
    totalDue: 3450,
    installments: '3/3',
    waiverSigned: true,
    intakeComplete: true,
    specialRequests: '',
  },
  {
    id: 3,
    name: 'Emma Williams',
    email: 'emma.w@outlook.co.uk',
    nationality: 'British',
    room: 'Shared Double - Oak Room',
    dietary: 'Pescatarian',
    allergies: ['Shellfish'],
    arrival: 'March 15, 16:45',
    flight: 'BA2761',
    totalPaid: 2600,
    totalDue: 2600,
    installments: '3/3',
    waiverSigned: true,
    intakeComplete: true,
    specialRequests: '',
  },
  {
    id: 4,
    name: 'Jan de Vries',
    email: 'jan.devries@ziggo.nl',
    nationality: 'Dutch',
    room: 'Private - Cedar Room',
    dietary: 'Vegetarian',
    allergies: [],
    arrival: 'March 15, 10:15',
    flight: 'KL1022',
    totalPaid: 3450,
    totalDue: 3450,
    installments: '3/3',
    waiverSigned: true,
    intakeComplete: true,
    specialRequests: 'No onion/garlic',
  },
  {
    id: 5,
    name: 'Lena Müller',
    email: 'l.mueller@web.de',
    nationality: 'German',
    room: 'Shared Double - Oak Room',
    dietary: 'Vegan',
    allergies: [],
    arrival: 'March 15, 13:20',
    flight: 'LH2302',
    totalPaid: 1750,
    totalDue: 2600,
    installments: '2/3',
    waiverSigned: true,
    intakeComplete: true,
    specialRequests: 'Low sodium',
  },
  {
    id: 6,
    name: 'Thomas Bakker',
    email: 'tbakker@gmail.com',
    nationality: 'Dutch',
    room: 'Shared Triple - Lotus Room',
    dietary: 'Omnivore',
    allergies: [],
    arrival: 'March 15, 15:30',
    flight: 'KL1456',
    totalPaid: 975,
    totalDue: 2925,
    installments: '1/3',
    waiverSigned: false,
    intakeComplete: false,
    specialRequests: '',
  },
  {
    id: 7,
    name: 'Sophie Laurent',
    email: 'sophie.l@orange.fr',
    nationality: 'French',
    room: 'Private - Willow Room',
    dietary: 'Vegetarian',
    allergies: ['Gluten'],
    arrival: 'March 15, 12:00',
    flight: 'AF1640',
    totalPaid: 3450,
    totalDue: 3450,
    installments: '3/3',
    waiverSigned: true,
    intakeComplete: true,
    specialRequests: '',
  },
  {
    id: 8,
    name: 'Klaus Hoffmann',
    email: 'k.hoffmann@gmx.de',
    nationality: 'German',
    room: 'Shared Triple - Lotus Room',
    dietary: 'Omnivore',
    allergies: ['Gluten'],
    arrival: 'March 15, 09:45',
    flight: 'LH2044',
    totalPaid: 2925,
    totalDue: 2925,
    installments: '3/3',
    waiverSigned: true,
    intakeComplete: true,
    specialRequests: 'Low sodium',
  },
  {
    id: 9,
    name: 'Anneke Jansen',
    email: 'anneke.j@kpn.nl',
    nationality: 'Dutch',
    room: 'Shared Double - Birch Room',
    dietary: 'Pescatarian',
    allergies: [],
    arrival: 'March 15, 17:00',
    flight: 'KL1678',
    totalPaid: 1750,
    totalDue: 2600,
    installments: '2/3',
    waiverSigned: true,
    intakeComplete: true,
    specialRequests: '',
  },
  {
    id: 10,
    name: 'David Thompson',
    email: 'david.t@btinternet.co.uk',
    nationality: 'British',
    room: 'Shared Double - Birch Room',
    dietary: 'Vegetarian',
    allergies: [],
    arrival: 'March 14, 20:30',
    flight: 'BA2759',
    totalPaid: 800,
    totalDue: 2600,
    installments: '1/3',
    waiverSigned: true,
    intakeComplete: false,
    specialRequests: '',
  },
];

// ─── Icon Components (inline SVG for zero dependencies) ───────────────────────

const Icons = {
  Leaf: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-6 h-6">
      <path d="M17 8C8 10 5.9 16.17 3.82 21.34l1.89.66.95-2.3c.48.17.98.3 1.34.3C19 20 22 3 22 3c-1 2-8 2.25-13 3.25S2 11.5 2 13.5s1.75 3.75 1.75 3.75" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Users: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-5 h-5">
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Euro: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-5 h-5">
      <path d="M4 10h12M4 14h12M17.5 4.5c-1.5-1-3.5-1.5-5.5-1.5C7 3 3 7 3 12s4 9 9 9c2 0 4-.5 5.5-1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Alert: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-5 h-5">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0zM12 9v4M12 17h.01" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Check: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4">
      <path d="M20 6L9 17l-5-5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Clock: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-4 h-4">
      <circle cx="12" cy="12" r="10" /><path d="M12 6v6l4 2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  ChevronDown: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4">
      <path d="M6 9l6 6 6-6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  ChevronUp: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4">
      <path d="M18 15l-6-6-6 6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Mail: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-5 h-5">
      <rect x="2" y="4" width="20" height="16" rx="2" /><path d="M22 7l-10 7L2 7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  FileText: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-5 h-5">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  ArrowRight: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4">
      <path d="M5 12h14M12 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Home: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-5 h-5">
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><path d="M9 22V12h6v10" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  BarChart: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-5 h-5">
      <path d="M12 20V10M18 20V4M6 20v-4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Lock: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-5 h-5">
      <rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Utensils: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-5 h-5">
      <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2M7 2v20M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3zm0 0v7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Plane: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-4 h-4">
      <path d="M17.8 19.2L16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
};

// ─── Sub-Components ───────────────────────────────────────────────────────────

function Header({ activeTab, setActiveTab }) {
  const tabs = [
    { id: 'dashboard', label: 'Dashboard', icon: Icons.Home },
    { id: 'guests', label: 'Guests', icon: Icons.Users },
    { id: 'kitchen', label: 'Kitchen', icon: Icons.Utensils },
    { id: 'payments', label: 'Payments', icon: Icons.Euro },
    { id: 'reports', label: 'Reports', icon: Icons.BarChart },
  ];

  return (
    <header className="bg-white border-b border-sage-100 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-sage-500 rounded-lg flex items-center justify-center text-white">
              <Icons.Leaf />
            </div>
            <span className="text-xl font-semibold text-sage-800" style={{ fontFamily: "'Playfair Display', serif" }}>
              RetreaTech
            </span>
          </div>

          {/* Navigation */}
          <nav className="hidden md:flex items-center gap-1">
            {tabs.map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                  activeTab === tab.id
                    ? 'bg-sage-100 text-sage-800'
                    : 'text-gray-500 hover:text-sage-700 hover:bg-sage-50'
                }`}
              >
                <tab.icon />
                {tab.label}
              </button>
            ))}
          </nav>

          {/* Mobile nav */}
          <div className="md:hidden text-sm text-gray-400">Demo Mode</div>
        </div>
      </div>
    </header>
  );
}

function StatCard({ icon: Icon, label, value, subtitle, accent }) {
  const accentColors = {
    green: 'bg-emerald-50 text-emerald-600 border-emerald-100',
    yellow: 'bg-amber-50 text-amber-600 border-amber-100',
    red: 'bg-red-50 text-red-600 border-red-100',
    blue: 'bg-blue-50 text-blue-600 border-blue-100',
    sage: 'bg-sage-50 text-sage-600 border-sage-100',
  };

  return (
    <div className="bg-white rounded-xl border border-gray-100 p-5 hover:shadow-md transition-shadow duration-300">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm text-gray-500 mb-1">{label}</p>
          <p className="text-2xl font-semibold text-gray-900">{value}</p>
          {subtitle && <p className="text-xs text-gray-400 mt-1">{subtitle}</p>}
        </div>
        <div className={`p-2.5 rounded-lg border ${accentColors[accent] || accentColors.sage}`}>
          <Icon />
        </div>
      </div>
    </div>
  );
}

function GuestCard({ guest, isExpanded, onToggle }) {
  const paymentPercent = Math.round((guest.totalPaid / guest.totalDue) * 100);

  return (
    <div className="bg-white rounded-xl border border-gray-100 hover:shadow-md transition-all duration-300 overflow-hidden">
      <button
        onClick={onToggle}
        className="w-full px-5 py-4 flex items-center justify-between text-left"
      >
        <div className="flex items-center gap-4">
          {/* Avatar */}
          <div className="w-10 h-10 rounded-full bg-sage-100 flex items-center justify-center text-sage-700 font-medium text-sm flex-shrink-0">
            {guest.name.split(' ').map(n => n[0]).join('').slice(0, 2)}
          </div>
          <div>
            <div className="flex items-center gap-2">
              <h3 className="font-medium text-gray-900">{guest.name}</h3>
              {guest.allergies.length > 0 && (
                <span className="px-2 py-0.5 bg-red-50 text-red-600 text-xs font-medium rounded-full border border-red-100">
                  Allergy Alert
                </span>
              )}
            </div>
            <p className="text-sm text-gray-500">{guest.room}</p>
          </div>
        </div>
        <div className="flex items-center gap-4">
          <div className="hidden sm:flex items-center gap-2">
            <span className={`w-2 h-2 rounded-full ${guest.intakeComplete ? 'bg-emerald-400' : 'bg-amber-400 animate-pulse-slow'}`} />
            <span className="text-xs text-gray-400">{guest.intakeComplete ? 'Complete' : 'Pending'}</span>
          </div>
          {isExpanded ? <Icons.ChevronUp /> : <Icons.ChevronDown />}
        </div>
      </button>

      {isExpanded && (
        <div className="px-5 pb-5 border-t border-gray-50 animate-slide-down">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
            {/* Dietary */}
            <div className="space-y-1">
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider">Dietary</p>
              <p className="text-sm text-gray-800">{guest.dietary}</p>
              {guest.allergies.length > 0 && (
                <div className="flex flex-wrap gap-1 mt-1">
                  {guest.allergies.map(a => (
                    <span key={a} className="px-2 py-0.5 bg-red-50 text-red-700 text-xs rounded-full border border-red-200 font-medium">
                      {a}
                    </span>
                  ))}
                </div>
              )}
              {guest.specialRequests && (
                <p className="text-xs text-amber-600 mt-1">Note: {guest.specialRequests}</p>
              )}
            </div>

            {/* Arrival */}
            <div className="space-y-1">
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider">Arrival</p>
              <div className="flex items-center gap-1.5 text-sm text-gray-800">
                <Icons.Plane />
                {guest.flight} — {guest.arrival}
              </div>
              <p className="text-xs text-gray-500">{guest.nationality}</p>
            </div>

            {/* Payment */}
            <div className="space-y-1">
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider">Payment</p>
              <p className="text-sm text-gray-800">
                €{guest.totalPaid.toLocaleString()} / €{guest.totalDue.toLocaleString()}
                <span className="text-gray-400 ml-1">({guest.installments})</span>
              </p>
              <div className="w-full bg-gray-100 rounded-full h-1.5 mt-1">
                <div
                  className={`h-1.5 rounded-full transition-all duration-500 ${
                    paymentPercent === 100 ? 'bg-emerald-400' : paymentPercent >= 50 ? 'bg-amber-400' : 'bg-red-400'
                  }`}
                  style={{ width: `${paymentPercent}%` }}
                />
              </div>
            </div>

            {/* Status row */}
            <div className="sm:col-span-2 lg:col-span-3 flex flex-wrap gap-3 pt-2">
              <StatusPill ok={guest.intakeComplete} label="Intake Form" />
              <StatusPill ok={guest.waiverSigned} label="Waiver Signed" />
              <StatusPill ok={paymentPercent === 100} label="Fully Paid" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function StatusPill({ ok, label }) {
  return (
    <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium ${
      ok ? 'bg-emerald-50 text-emerald-700 border border-emerald-100' : 'bg-amber-50 text-amber-700 border border-amber-100'
    }`}>
      {ok ? <Icons.Check /> : <Icons.Clock />}
      {label}
    </span>
  );
}

// ─── Dashboard Tab ────────────────────────────────────────────────────────────

function DashboardView({ setActiveTab }) {
  return (
    <div className="space-y-8 animate-fade-in">
      {/* Retreat Header */}
      <div className="bg-white rounded-2xl border border-gray-100 p-6 sm:p-8">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <p className="text-sm text-sage-500 font-medium uppercase tracking-wider mb-1">Upcoming Retreat</p>
            <h2 className="text-2xl sm:text-3xl font-semibold text-gray-900" style={{ fontFamily: "'Playfair Display', serif" }}>
              Spring Renewal Retreat
            </h2>
            <p className="text-gray-500 mt-1">March 15 – 22, 2026 &middot; Yoga, Meditation & Wellness</p>
          </div>
          <div className="flex items-center gap-2 px-4 py-2 bg-sage-50 rounded-lg border border-sage-100">
            <div className="w-2 h-2 rounded-full bg-sage-400 animate-pulse-slow" />
            <span className="text-sm font-medium text-sage-700">Bookings Open</span>
          </div>
        </div>
      </div>

      {/* Stat Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard icon={Icons.Users} label="Guests Booked" value="24 / 30" subtitle="6 spots remaining" accent="sage" />
        <StatCard icon={Icons.Euro} label="Revenue" value="€47,200" subtitle="of €58,500 total" accent="green" />
        <StatCard icon={Icons.Check} label="Fully Paid" value="18" subtitle="6 pending installments" accent="blue" />
        <StatCard icon={Icons.Alert} label="Dietary Alerts" value="3" subtitle="Need kitchen attention" accent="red" />
      </div>

      {/* Automation Flow */}
      <div>
        <h3 className="text-lg font-semibold text-gray-800 mb-4">How Automation Works</h3>
        <AutomationFlow />
      </div>

      {/* Quick Actions */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <button
          onClick={() => setActiveTab('guests')}
          className="bg-white rounded-xl border border-gray-100 p-5 text-left hover:shadow-md hover:border-sage-200 transition-all duration-300 group"
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="font-medium text-gray-800">View Guest List</p>
              <p className="text-sm text-gray-500 mt-0.5">24 guests, 2 incomplete intakes</p>
            </div>
            <span className="text-sage-400 group-hover:translate-x-1 transition-transform"><Icons.ArrowRight /></span>
          </div>
        </button>
        <button
          onClick={() => setActiveTab('kitchen')}
          className="bg-white rounded-xl border border-gray-100 p-5 text-left hover:shadow-md hover:border-sage-200 transition-all duration-300 group"
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="font-medium text-gray-800">Kitchen Report</p>
              <p className="text-sm text-gray-500 mt-0.5">3 critical allergies flagged</p>
            </div>
            <span className="text-sage-400 group-hover:translate-x-1 transition-transform"><Icons.ArrowRight /></span>
          </div>
        </button>
        <button
          onClick={() => setActiveTab('payments')}
          className="bg-white rounded-xl border border-gray-100 p-5 text-left hover:shadow-md hover:border-sage-200 transition-all duration-300 group"
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="font-medium text-gray-800">Payment Tracking</p>
              <p className="text-sm text-gray-500 mt-0.5">1 overdue, 5 upcoming</p>
            </div>
            <span className="text-sage-400 group-hover:translate-x-1 transition-transform"><Icons.ArrowRight /></span>
          </div>
        </button>
      </div>
    </div>
  );
}

// ─── Automation Flow ──────────────────────────────────────────────────────────

function AutomationFlow() {
  const steps = [
    { icon: Icons.Mail, title: 'Booking Received', desc: 'Auto-confirmation email sent instantly', color: 'bg-sage-500' },
    { icon: Icons.Clock, title: '7 Days Before', desc: 'Intake form request sent automatically', color: 'bg-sage-500' },
    { icon: Icons.FileText, title: 'Form Completed', desc: 'Data syncs to Kitchen, Transport & Rooms', color: 'bg-sage-500' },
    { icon: Icons.Check, title: '48 Hours Before', desc: 'Final reports generated & staff notified', color: 'bg-sage-500' },
  ];

  return (
    <div className="bg-white rounded-xl border border-gray-100 p-6">
      <div className="flex flex-col md:flex-row md:items-start gap-4 md:gap-0">
        {steps.map((step, i) => (
          <React.Fragment key={i}>
            <div className="flex md:flex-col items-start md:items-center gap-3 md:gap-2 md:flex-1 md:text-center">
              <div className={`w-10 h-10 ${step.color} rounded-full flex items-center justify-center text-white flex-shrink-0`}>
                <step.icon />
              </div>
              <div>
                <p className="text-sm font-semibold text-gray-800">{step.title}</p>
                <p className="text-xs text-gray-500 mt-0.5 max-w-[180px]">{step.desc}</p>
              </div>
            </div>
            {i < steps.length - 1 && (
              <div className="hidden md:flex items-center justify-center flex-shrink-0 pt-5 px-2 text-sage-300">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5">
                  <path d="M5 12h14M12 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
            )}
          </React.Fragment>
        ))}
      </div>

      {/* Sync destinations */}
      <div className="mt-6 pt-5 border-t border-gray-50">
        <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-3">Auto-syncs to:</p>
        <div className="flex flex-wrap gap-2">
          {['Kitchen Report', 'Transport Schedule', 'Room Assignments', 'Staff Notifications'].map(item => (
            <span key={item} className="px-3 py-1.5 bg-sage-50 text-sage-700 text-xs font-medium rounded-lg border border-sage-100">
              {item}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

// ─── Guests Tab ───────────────────────────────────────────────────────────────

function GuestsView() {
  const [expandedId, setExpandedId] = useState(null);

  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-xl font-semibold text-gray-800">Guest Management</h2>
          <p className="text-sm text-gray-500 mt-0.5">Spring Renewal Retreat — 24 guests booked</p>
        </div>
        <div className="flex items-center gap-2">
          <span className="flex items-center gap-1.5 px-3 py-1.5 bg-emerald-50 text-emerald-700 text-xs font-medium rounded-full border border-emerald-100">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-400" /> 8 complete
          </span>
          <span className="flex items-center gap-1.5 px-3 py-1.5 bg-amber-50 text-amber-700 text-xs font-medium rounded-full border border-amber-100">
            <span className="w-1.5 h-1.5 rounded-full bg-amber-400" /> 2 pending
          </span>
        </div>
      </div>

      {/* Intake Timeline Demo */}
      <div className="bg-cream-50 rounded-xl border border-cream-200 p-5">
        <p className="text-xs font-medium text-sage-600 uppercase tracking-wider mb-3">Intake Automation Timeline — Sample</p>
        <div className="flex flex-wrap items-center gap-2 text-xs">
          {[
            'Guest Books',
            'Auto-confirmation sent',
            'Intake form triggered (7 days before)',
            'Guest completes form',
            'Data synced to all reports',
          ].map((step, i, arr) => (
            <React.Fragment key={i}>
              <span className="px-3 py-1.5 rounded-lg font-medium bg-sage-100 text-sage-700">
                <span className="text-sage-500 mr-1">&#10003;</span>
                {step}
              </span>
              {i < arr.length - 1 && <span className="text-sage-300">&rarr;</span>}
            </React.Fragment>
          ))}
        </div>
      </div>

      {/* Guest List */}
      <div className="space-y-3">
        {guests.map(guest => (
          <GuestCard
            key={guest.id}
            guest={guest}
            isExpanded={expandedId === guest.id}
            onToggle={() => setExpandedId(expandedId === guest.id ? null : guest.id)}
          />
        ))}
      </div>
    </div>
  );
}

// ─── Kitchen Tab ──────────────────────────────────────────────────────────────

function KitchenView() {
  const [showReport, setShowReport] = useState(false);

  const today = new Date().toLocaleDateString('en-GB', {
    day: 'numeric', month: 'long', year: 'numeric',
  });

  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-xl font-semibold text-gray-800">Kitchen Report</h2>
          <p className="text-sm text-gray-500 mt-0.5">Auto-generated dietary summary for kitchen staff</p>
        </div>
        <button
          onClick={() => setShowReport(true)}
          className="px-4 py-2 bg-sage-500 text-white text-sm font-medium rounded-lg hover:bg-sage-600 transition-colors"
        >
          Generate Report
        </button>
      </div>

      {/* Report */}
      <div className={`transition-all duration-500 ${showReport ? 'opacity-100' : 'opacity-60'}`}>
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
          {/* Report header */}
          <div className="bg-sage-700 text-white px-6 py-4">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="font-semibold text-lg">KITCHEN REPORT</h3>
                <p className="text-sage-200 text-sm">Spring Renewal Retreat</p>
              </div>
              <div className="text-right text-sm text-sage-200">
                <p>Generated: {today}</p>
                <p>Total Guests: 24</p>
              </div>
            </div>
          </div>

          <div className="p-6 space-y-6">
            {/* Dietary Breakdown */}
            <div>
              <h4 className="font-semibold text-gray-800 mb-3">Dietary Breakdown</h4>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                {[
                  { label: 'Omnivore', count: 12, color: 'bg-gray-100 text-gray-700' },
                  { label: 'Vegetarian', count: 5, color: 'bg-green-50 text-green-700' },
                  { label: 'Vegan', count: 4, color: 'bg-emerald-50 text-emerald-700' },
                  { label: 'Pescatarian', count: 3, color: 'bg-blue-50 text-blue-700' },
                ].map(item => (
                  <div key={item.label} className={`${item.color} rounded-lg p-3 text-center`}>
                    <p className="text-2xl font-bold">{item.count}</p>
                    <p className="text-xs font-medium mt-0.5">{item.label}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Critical Allergies */}
            <div>
              <h4 className="font-semibold text-red-700 mb-3 flex items-center gap-2">
                <Icons.Alert />
                Critical Allergies — RED ALERT
              </h4>
              <div className="space-y-2">
                <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                  <div className="flex items-start justify-between">
                    <div>
                      <p className="font-semibold text-red-800">Tree Nuts — 2 guests</p>
                      <ul className="text-sm text-red-700 mt-1 space-y-0.5">
                        <li>&#8226; Sarah van der Berg — Lotus Room</li>
                        <li>&#8226; Michael Chen — Bamboo Room</li>
                      </ul>
                    </div>
                    <span className="px-2 py-0.5 bg-red-200 text-red-800 text-xs font-bold rounded">CRITICAL</span>
                  </div>
                </div>
                <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                  <div className="flex items-start justify-between">
                    <div>
                      <p className="font-semibold text-red-800">Shellfish — 1 guest</p>
                      <ul className="text-sm text-red-700 mt-1">
                        <li>&#8226; Emma Williams — Oak Room</li>
                      </ul>
                    </div>
                    <span className="px-2 py-0.5 bg-red-200 text-red-800 text-xs font-bold rounded">CRITICAL</span>
                  </div>
                </div>
                <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
                  <p className="font-semibold text-amber-800">Celiac / Gluten-Free — 2 guests</p>
                  <ul className="text-sm text-amber-700 mt-1 space-y-0.5">
                    <li>&#8226; Sophie Laurent — Willow Room</li>
                    <li>&#8226; Klaus Hoffmann — Lotus Room</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Special Requests */}
            <div>
              <h4 className="font-semibold text-gray-800 mb-3">Special Requests</h4>
              <div className="bg-cream-50 border border-cream-200 rounded-lg p-4 space-y-2 text-sm text-gray-700">
                <p>&#8226; <strong>No onion/garlic:</strong> 1 guest (Jan de Vries)</p>
                <p>&#8226; <strong>Low sodium:</strong> 2 guests (Lena M&#252;ller, Klaus Hoffmann)</p>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="border-t border-gray-100 px-6 py-3 bg-gray-50 text-xs text-gray-400 flex items-center justify-between">
            <span>Auto-generated by RetreaTech</span>
            <span>Print-ready format</span>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Payments Tab ─────────────────────────────────────────────────────────────

function PaymentsView() {
  const paymentData = guests.map(g => ({
    ...g,
    remaining: g.totalDue - g.totalPaid,
    nextDue: g.totalPaid === g.totalDue ? '\u2014' : g.installments === '1/3' ? 'Feb 15, 2026' : 'Mar 1, 2026',
    status: g.totalPaid === g.totalDue ? 'paid' : g.installments === '1/3' ? 'overdue' : 'upcoming',
  }));

  const statusConfig = {
    paid: { label: 'Paid', className: 'bg-emerald-50 text-emerald-700 border-emerald-100' },
    upcoming: { label: 'Upcoming', className: 'bg-amber-50 text-amber-700 border-amber-100' },
    overdue: { label: 'Overdue', className: 'bg-red-50 text-red-700 border-red-100' },
  };

  return (
    <div className="space-y-6 animate-fade-in">
      <div>
        <h2 className="text-xl font-semibold text-gray-800">Payment Tracking</h2>
        <p className="text-sm text-gray-500 mt-0.5">Automated installment tracking and reminders</p>
      </div>

      {/* Summary */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="bg-emerald-50 border border-emerald-100 rounded-xl p-4 text-center">
          <p className="text-2xl font-bold text-emerald-700">&euro;47,200</p>
          <p className="text-sm text-emerald-600">Collected</p>
        </div>
        <div className="bg-amber-50 border border-amber-100 rounded-xl p-4 text-center">
          <p className="text-2xl font-bold text-amber-700">&euro;11,300</p>
          <p className="text-sm text-amber-600">Outstanding</p>
        </div>
        <div className="bg-sage-50 border border-sage-100 rounded-xl p-4 text-center">
          <p className="text-2xl font-bold text-sage-700">&euro;58,500</p>
          <p className="text-sm text-sage-600">Total Expected</p>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-gray-50 border-b border-gray-100">
                <th className="text-left py-3 px-4 font-medium text-gray-500">Guest</th>
                <th className="text-right py-3 px-4 font-medium text-gray-500">Total</th>
                <th className="text-right py-3 px-4 font-medium text-gray-500">Paid</th>
                <th className="text-right py-3 px-4 font-medium text-gray-500">Remaining</th>
                <th className="text-left py-3 px-4 font-medium text-gray-500">Next Due</th>
                <th className="text-left py-3 px-4 font-medium text-gray-500">Status</th>
              </tr>
            </thead>
            <tbody>
              {paymentData.map((g, i) => (
                <tr key={g.id} className={`border-b border-gray-50 ${i % 2 === 0 ? '' : 'bg-gray-50/30'} hover:bg-sage-50/50 transition-colors`}>
                  <td className="py-3 px-4">
                    <p className="font-medium text-gray-800">{g.name}</p>
                    <p className="text-xs text-gray-400">{g.room}</p>
                  </td>
                  <td className="py-3 px-4 text-right text-gray-700">&euro;{g.totalDue.toLocaleString()}</td>
                  <td className="py-3 px-4 text-right text-gray-700">&euro;{g.totalPaid.toLocaleString()}</td>
                  <td className="py-3 px-4 text-right font-medium text-gray-800">
                    {g.remaining > 0 ? `€${g.remaining.toLocaleString()}` : '\u2014'}
                  </td>
                  <td className="py-3 px-4 text-gray-600">{g.nextDue}</td>
                  <td className="py-3 px-4">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${statusConfig[g.status].className}`}>
                      {statusConfig[g.status].label}
                    </span>
                    {g.status === 'overdue' && (
                      <p className="text-xs text-red-500 mt-1">Auto-reminder sent 2 days ago</p>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

// ─── Reports Tab (includes Partner Portal preview) ────────────────────────────

function ReportsView() {
  return (
    <div className="space-y-8 animate-fade-in">
      <div>
        <h2 className="text-xl font-semibold text-gray-800">Reports & Partner Portal</h2>
        <p className="text-sm text-gray-500 mt-0.5">Generated reports and partner access management</p>
      </div>

      {/* Partner Portal Preview */}
      <div>
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Partner Portal Preview</h3>
        <div className="bg-white rounded-xl border-2 border-dashed border-sage-200 overflow-hidden">
          {/* Partner header bar */}
          <div className="bg-sage-50 border-b border-sage-100 px-6 py-3 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Icons.Lock />
              <span className="text-sm font-medium text-sage-700">Retreat Leader View — Limited Access</span>
            </div>
            <span className="text-xs text-sage-500 bg-sage-100 px-2 py-0.5 rounded">Partner Login</span>
          </div>

          <div className="p-6 space-y-5">
            {/* What partner sees */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="border border-gray-100 rounded-lg p-4">
                <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-2">Their Retreat</p>
                <p className="font-medium text-gray-800">Spring Renewal Retreat</p>
                <p className="text-sm text-gray-500">March 15 – 22, 2026</p>
                <p className="text-sm text-sage-600 mt-1">24 / 30 spots filled</p>
              </div>
              <div className="border border-gray-100 rounded-lg p-4">
                <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-2">Payment Summary</p>
                <p className="font-medium text-gray-800">&euro;47,200 collected</p>
                <p className="text-sm text-gray-500">&euro;11,300 outstanding</p>
                <p className="text-sm text-sage-600 mt-1">18 of 24 fully paid</p>
              </div>
            </div>

            <div className="border border-gray-100 rounded-lg p-4">
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-2">Guest Overview (Names & Dietary Only)</p>
              <div className="space-y-1.5">
                {guests.slice(0, 5).map(g => (
                  <div key={g.id} className="flex items-center justify-between text-sm py-1 border-b border-gray-50 last:border-0">
                    <span className="text-gray-700">{g.name}</span>
                    <span className="text-gray-500">{g.dietary}{g.allergies.length > 0 ? ` (${g.allergies.join(', ')})` : ''}</span>
                  </div>
                ))}
                <p className="text-xs text-gray-400 pt-1">... and 19 more guests</p>
              </div>
            </div>

            {/* Access restrictions */}
            <div className="flex flex-wrap gap-2">
              <span className="px-3 py-1.5 bg-emerald-50 text-emerald-700 text-xs font-medium rounded-lg border border-emerald-100">
                &#10003; View own retreat bookings
              </span>
              <span className="px-3 py-1.5 bg-emerald-50 text-emerald-700 text-xs font-medium rounded-lg border border-emerald-100">
                &#10003; Guest names & dietary info
              </span>
              <span className="px-3 py-1.5 bg-emerald-50 text-emerald-700 text-xs font-medium rounded-lg border border-emerald-100">
                &#10003; Payment summary
              </span>
              <span className="px-3 py-1.5 bg-red-50 text-red-600 text-xs font-medium rounded-lg border border-red-100">
                &#10007; Other retreats
              </span>
              <span className="px-3 py-1.5 bg-red-50 text-red-600 text-xs font-medium rounded-lg border border-red-100">
                &#10007; Financial details
              </span>
              <span className="px-3 py-1.5 bg-red-50 text-red-600 text-xs font-medium rounded-lg border border-red-100">
                &#10007; Admin settings
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Full Automation Flow Diagram */}
      <div>
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Complete Automation Workflow</h3>
        <div className="bg-white rounded-xl border border-gray-100 p-6">
          <div className="space-y-0">
            {[
              { step: 'BOOKING', desc: 'Guest books online', result: 'Auto-email confirmation sent', color: 'bg-sage-500' },
              { step: '7 DAYS BEFORE', desc: 'System triggers intake', result: 'Intake form request emailed to guest', color: 'bg-sage-500' },
              { step: 'FORM COMPLETED', desc: 'Guest submits info', result: 'Data auto-syncs to Kitchen Report, Transport Schedule, Room Assignment', color: 'bg-sage-600' },
              { step: '48 HOURS BEFORE', desc: 'Final preparation', result: 'Reports generated, staff notifications sent', color: 'bg-sage-700' },
            ].map((item, i, arr) => (
              <div key={i} className="flex gap-4">
                {/* Timeline line */}
                <div className="flex flex-col items-center">
                  <div className={`w-10 h-10 ${item.color} rounded-full flex items-center justify-center text-white flex-shrink-0`}>
                    <span className="text-sm font-bold">{i + 1}</span>
                  </div>
                  {i < arr.length - 1 && (
                    <div className="w-0.5 h-16 bg-sage-200 my-1" />
                  )}
                </div>
                <div className="pb-8">
                  <p className="text-xs font-bold text-sage-600 uppercase tracking-wider">{item.step}</p>
                  <p className="font-medium text-gray-800 mt-0.5">{item.desc}</p>
                  <p className="text-sm text-gray-500 mt-0.5">{item.result}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Main App ─────────────────────────────────────────────────────────────────

function App() {
  const [activeTab, setActiveTab] = useState('dashboard');

  const renderTab = () => {
    switch (activeTab) {
      case 'dashboard': return <DashboardView setActiveTab={setActiveTab} />;
      case 'guests': return <GuestsView />;
      case 'kitchen': return <KitchenView />;
      case 'payments': return <PaymentsView />;
      case 'reports': return <ReportsView />;
      default: return <DashboardView setActiveTab={setActiveTab} />;
    }
  };

  return (
    <div className="min-h-screen bg-warmgray-50">
      <Header activeTab={activeTab} setActiveTab={setActiveTab} />

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        {renderTab()}
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-100 bg-white mt-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 bg-sage-500 rounded flex items-center justify-center text-white">
              <Icons.Leaf />
            </div>
            <span className="text-sm text-gray-500">
              Demo by <strong className="text-gray-700">Koen Wensing</strong> — Retreat Tech Solutions
            </span>
          </div>
          <a
            href="https://koenwensing.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-sage-600 hover:text-sage-700 font-medium transition-colors"
          >
            koenwensing.com
          </a>
        </div>
      </footer>
    </div>
  );
}

export default App;
